import { errorToast } from "@app/design-system/components/toast";
import { StudentGroup } from "@core/account/types";
import { getActiveForm } from "@mongez/react-form";
import { Random } from "@mongez/reinforcements";
import { useRef, useState } from "react";
import { useAction } from "../../shared/hooks";

export function useCreateAccountGroups() {
  const [groups, setGroups] = useState<StudentGroup[]>([]);
  const idRef = useRef(Random.string(16));
  const [isLoading, setIsLoading] = useState(false);

  const requestGroups = useAction("/account/groups");

  const updateGroups = async () => {
    idRef.current = Random.string(16);

    const form = getActiveForm();

    const grade = form!.value("grade");
    const gender = form!.value("gender");
    const teachingLanguage = form!.value("teachingLanguage");

    if (!grade || !gender) {
      return;
    }

    setIsLoading(true);
    setGroups([]);

    const requestData: {
      grade: string | number;
      gender: "male" | "female";
      teachingLanguage?: string;
    } = {
      grade,
      gender,
    };

    // Only include teachingLanguage if it's provided
    if (teachingLanguage) {
      requestData.teachingLanguage = teachingLanguage;
    }

    const { data, isOK, error } = await requestGroups(requestData);

    setIsLoading(false);

    if (isOK) {
      idRef.current = Random.string(16);

      setGroups(data);
    } else {
      errorToast(error);
    }
  };

  return {
    groups,
    updateGroups,
    id: idRef.current,
    isLoading,
  };
}
